import { Injectable, inject } from '@angular/core';
import { environment } from '@environment/environment';
import { TranslateService } from '@ngx-translate/core';
import { FooterRepository } from '@repositories/footer.repository';
import { RestApiService } from '@services/rest-api/rest-api.service';

@Injectable({
    providedIn: 'root'
})
export class FooterAdapter extends FooterRepository {
  private readonly apiService = inject(RestApiService);
  private readonly translateService = inject(TranslateService);

  constructor() { super(); }

  GetFooter() {
    const isLangEn = this.translateService.currentLang === 'en';
    const urlLang = isLangEn ? 'en/' : '';
    return this.apiService.getRequest(`${environment.drupalApi + urlLang}views/footer_rest`, null);
  }

}
